import React from 'react';
import { useOutletContext } from 'react-router-dom';

export default function TeacherLandingAbout() {
  const { content, openContact } = useOutletContext();
  const a = content.about;

  return (
    <main>
      <section className="tl-about-hero">
        <div className="tl-wrap">
          <span className="tl-badge">{a.heroBadge}</span>
          <h1 className="tl-serif tl-h1" style={{ marginTop: '1rem' }}>
            {a.heroTitle}
          </h1>
        </div>
      </section>

      <section className="tl-section">
        <div className="tl-wrap tl-about-intro">
          <aside className="tl-profile-card">
            <p className="tl-profile-card-eyebrow">{a.profileCardEyebrow}</p>
            <img
              className="tl-profile-avatar"
              src={content.images.teacherPortraitAbout}
              alt={content.teacherName}
            />
            <h3 className="tl-serif tl-profile-name">{content.teacherName}</h3>
            <p>{a.profileCardBio}</p>
          </aside>
          <div>
            <p className="tl-eyebrow">{a.partnerEyebrow}</p>
            <h2 className="tl-serif tl-h2">{content.teacherName}</h2>
            <p className="tl-lead">{a.intro}</p>
          </div>
        </div>
        <div className="tl-wrap">
          <div className="tl-stats-4">
            {a.stats.map((s) => (
              <div key={s.label}>
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="tl-section tl-section-muted">
        <div className="tl-wrap tl-split">
          <div className="tl-story-visual">
            <img src={content.images.storyDiploma} alt="" />
            <div className="tl-quote-chip">{a.storyQuote}</div>
          </div>
          <div>
            <p className="tl-eyebrow">{a.storyEyebrow}</p>
            <h2 className="tl-serif tl-h2">{a.storyTitle}</h2>
            {a.storyBody.map((p) => (
              <p key={p.slice(0, 32)} className="tl-lead" style={{ marginBottom: '0.85rem' }}>
                {p}
              </p>
            ))}
          </div>
        </div>
      </section>

      <section className="tl-section">
        <div className="tl-wrap">
          <p className="tl-eyebrow">{a.qualEyebrow}</p>
          <h2 className="tl-serif tl-h2">{a.qualTitle}</h2>
          <div className="tl-qual-grid">
            {a.qualifications.map((q) => (
              <article key={q.title} className={`tl-qual-card tl-qual-${q.tone}`}>
                <span className="year">{q.year}</span>
                <h3 className="tl-serif">{q.title}</h3>
                <p>{q.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="tl-section tl-section-muted">
        <div className="tl-wrap">
          <p className="tl-eyebrow tl-center">{a.methodEyebrow}</p>
          <h2 className="tl-serif tl-h2 tl-center">{a.methodTitle}</h2>
          <div className="tl-steps">
            {a.steps.map((s) => (
              <article key={s.n} className="tl-step">
                <div className="n">{s.n}</div>
                <h3 className="tl-serif">{s.title}</h3>
                <p>{s.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="tl-band">
        <div className="tl-wrap">
          <h2 className="tl-serif tl-h2">{a.bandTitle}</h2>
          <p>{a.bandBody}</p>
          <button type="button" className="tl-btn tl-btn-light" onClick={openContact}>
            {a.bandCta}
          </button>
        </div>
      </section>
    </main>
  );
}
